import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";

import { semanticColors, textStyles } from "@/designTokens";

const useStyles = makeStyles({
  link: {
    ...textStyles["SP/Button/M"],
    color: semanticColors["text/link"],
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": { color: semanticColors["action/primary-hover"] },
    "& > span, & > .MuiTypography-root": { fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit" },
  },
  underline: { textDecoration: "underline", textUnderlineOffset: "3px" },
  arrow: { display: "inline-flex", alignItems: "center", gap: 8 },
  arrowIcon: { display: "block", flexShrink: 0 },
});
interface TextLinkProps {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
  targetBlank?: boolean;
  underline?: boolean;
  bold?: boolean; // 旧API。v2のリンクはMedium固定。
  arrow?: boolean;
  size?: "M" | "S";
}
export const TextLink: React.FC<TextLinkProps> = ({
  href,
  children,
  underline = false,
  onClick,
  targetBlank = false,
  arrow = !underline,
  size = "M",
}) => {
  const classes = useStyles();
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };
  return (
    <Typography
      component="a"
      href={href}
      className={`${classes.link} ${underline ? classes.underline : ""} ${arrow ? classes.arrow : ""}`}
      onClick={handleClick}
      target={targetBlank ? "_blank" : undefined}
      rel={targetBlank ? "noopener noreferrer" : undefined}
      style={size === "S" ? { fontSize: textStyles["SP/Button/S"].fontSize } : undefined}
    >
      {children}
      {arrow && <img src="/icons/ds-v2-link-chevron.svg" className={classes.arrowIcon} alt="" aria-hidden="true" />}
    </Typography>
  );
};
